import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import CascaderMetricSelect from '@intelligence/components/CascaderMetricSelect';
import { getStringArrayValue } from '../shared/valueUtils';
import { tagSelectControl } from '../tagSelect';
import { COMMON_JOINER } from '@intelligence/utils/topchartsUtils';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule } from '../controlModule';
import type { ISensorTowerThemeValue } from './types';

import ICON_SENSORTOWER from '@intelligence/assets/svg/dataSource/sensor-tower.svg';

const language = {
  en: {
    region_title: 'Theme',
    button_region: 'Theme',
  },
  cn: {
    region_title: '主题',
    button_region: '主题',
  },
};

const SensorTowerThemeRenderer: React.FC<IFilterRenderProps<ISensorTowerThemeValue>> = (props) => {
  const { className, field, value, onChange, ...rest } = props;
  const { locale } = useIntl();

  return (
    // @ts-expect-error CascaderMetricSelect 缺少完整 props 类型定义
    <CascaderMetricSelect
      {...rest}
      key={field}
      className={classnames('dbi-sensotower-cascader-select', className)}
      buttonType="3"
      locale={locale}
      language={language}
      value={getStringArrayValue(value)}
      joiner={COMMON_JOINER}
      titleIcon={ICON_SENSORTOWER}
      onConfirm={(payload: string[]) => {
        onChange(payload);
      }}
    />
  );
};

const getRenderPreview = (): NonNullable<IFilterTypeEntry['renderPreview']> => {
  // eslint-disable-next-line react/display-name
  return (item, value) => tagSelectControl.getRenderPreview?.({})?.(item, value) || null;
};

export const sensorTowerThemeControl: IFilterControlModule = {
  type: FILTER_TYPE.SENSOR_TOWER_THEME,
  entry: {
    render: (props) => {
      return <SensorTowerThemeRenderer {...props} />;
    },
  },
  getRenderPreview,
};
